$(document).ready(function(){
    $linkTableCell = $('.table .linked');

    $linkTableCell.on('click', function(){
        window.location = $(this).parent().data("link");
    })
});